module.exports = __webpack_public_path__ + "img/top.784ccef8.png";